import { LAYOUT_CONFIG } from "@circle-react-uikit/CircleAIAppShell/Layout/defaults";
import { useDesktopShellEngine } from "@circle-react-uikit/CircleAIAppShell/Layout/desktopShellEngineContext";
import { FlexHandle } from "@circle-react-uikit/CircleAIAppShell/Layout/Resizable/FlexHandle";
import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { DesktopShell } from "@circleco/compass/components/DesktopShell";
import { useEffect } from "react";

import { t } from "@/i18n-js/instance";

interface SidebarResizeHandleProps {
  maxWidth?: number;
}

export const SidebarResizeHandle = ({
  maxWidth = LAYOUT_CONFIG.communityLeftSidebar.maxWidth,
}: SidebarResizeHandleProps) => {
  const engine = useDesktopShellEngine();
  const isVisible = useCircleAIShellStore(s => s.isLeftSidebarVisible);
  const width = useCircleAIShellStore(s => s.leftSidebarWidth);
  const minWidth = useCircleAIShellStore(s => s.leftSidebarMinWidth);
  const onResize = useCircleAIShellStore(s => s.setLeftSidebarWidth);

  useEffect(() => {
    if (width > maxWidth) onResize(maxWidth);
  }, [maxWidth, onResize, width]);

  const hiddenProps = {
    className: !isVisible ? "pointer-events-none cursor-default" : undefined,
    tabIndex: !isVisible ? -1 : undefined,
    "aria-hidden": !isVisible || undefined,
  };

  if (engine === "circle") {
    return (
      <FlexHandle
        aria-label={t("circle_ai_shell.resize_sidebar")}
        width={width}
        direction={1}
        minWidth={minWidth}
        maxWidth={maxWidth}
        onResize={onResize}
        {...hiddenProps}
      />
    );
  }

  return (
    <DesktopShell.ResizeHandle
      aria-label={t("circle_ai_shell.resize_sidebar")}
      edge="end"
      width={width}
      minWidth={minWidth}
      maxWidth={maxWidth}
      onResize={onResize}
      {...hiddenProps}
    />
  );
};

SidebarResizeHandle.displayName = "CircleAIAppShell.SidebarResizeHandle";
